import { z } from "zod";

const envSchema = z.object({
	MODE: z.enum(["development", "production", "test"]).default("development"),
	VITE_API_URL: z.string(),
	VITE_BRASIL_API_URL: z.string(),
	VITE_URL_OFFER_MONETIZZE: z.string(),
});

export const env = envSchema.parse(import.meta.env);
